import React, { ReactElement } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { PricingRoutes } from 'pricing/types';
import ContractList from 'pricing/pages/contractList/ContractList';
import ContractCreate from 'pricing/pages/contractCreate/ContractCreate';
import ContractEdit from 'pricing/pages/contractEdit/ContractEdit';
import ContractView from 'pricing/pages/contractView/ContractView';
import { useUserCapabilities } from 'shared/hooks';
import { UserCapabilities } from 'utilities/const';

export const Pricing = (): ReactElement | null => {
  const { capabilities, loadingCapabilities } = useUserCapabilities();

  if (loadingCapabilities) return null;

  return capabilities.includes(UserCapabilities.UsePricingApp) ? (
    <Switch>
      <Route
        path={`${PricingRoutes.ContractList}/:category?/:query?`}
        component={ContractList}
        exact
      />
      <Route path={PricingRoutes.ContractCreate} exact component={ContractCreate} />
      <Route
        path={`${PricingRoutes.ContractEdit}/:contractId`}
        component={ContractEdit}
      />
      <Route
        path={`${PricingRoutes.ContractView}/:contractId`}
        component={ContractView}
      />
    </Switch>
  ) : (
    <Switch>
      <Redirect to="/dashboard" />
    </Switch>
  );
};
